export const consultantLandingLocaleData: Record<string, Record<string, string>> = {
  'zh-tw': {
    'consultantLanding.title': '你能成為 BRAIN 研究顧問嗎?',
    'consultantLanding.title.logged': '加入 BRAIN 研究顧問計畫!',
    'consultantLanding.joinHeader': '探索<b>量化金融的世界!</b>',
    'consultantLanding.joinHeader.logged': '加入全球最<b>大的量化金融社群之一</b>！',
    'consultantLanding.leverageOurData': '運用WorldQuant BRAIN模擬平台構建Alphas*，為WorldQuant整體研究工作做出貢獻。',
    'consultantLanding.leverageOurData.asterix': '\u002A WorldQuant所定義的Alphas為用來試圖預測各種金融資產未來價格變動的數學模型。',
    'consultantLanding.userCount': '使用者',
    'consultantLanding.userCount.number': '550,000+',
    'consultantLanding.consultantCount': '研究顧問',
    'consultantLanding.consultantCount.number': '16,000+',
    'consultantLanding.countriesCount': '區域',
    'consultantLanding.countriesCount.number': '17',
    'consultantLanding.availableInCountries': 'BRAIN研究顧問計畫目前適用於',
    'consultantLanding.countryList':
      '中國大陸、香港、台灣、肯亞、南韓、印尼、印度、馬來西亞、新加坡、英國、越南、泰國、美國、亞美尼亞、尼日利亞以及喬治亞。',
    'consultantLanding.joinUs': '加入我們',
    'consultantLanding.featuresHeader': '解鎖專屬功能 🔑',
    'consultantLanding.additionalFields': '更多的資料欄與區域',
    'consultantLanding.exploreAdditional': '探索12個地區、超過400,000個資料欄',
    'consultantLanding.moreFeatures': '進階功能',
    'consultantLanding.openAccess':
      '取得進階功能: 更長的模擬週期、視覺化資料、多重模擬、透過Python使用BRAIN的API、建構SuperAlphas…等等更多功能!',
    'consultantLanding.moreLearning': '量化指導計畫',
    'consultantLanding.moreAdvancedVideos': '由資深量化研究員帶領的同儕制學習，並提供實作指導',
    'consultantLanding.meritBased': '基於績效的報酬制度',
    'consultantLanding.compensationOpportunity':
      '有機會根據您策略的品質獲得報酬\nGrandmaster 級別顧問有機會獲得8,000美元或更多的季度獎金\nMaster 級別顧問有機會獲得2,000美元或更多的季度獎金',
    'consultantLanding.career': '潛在職涯發展機會',
    'consultantLanding.internships': '有機會被考慮為WorldQuant實習與正職職位候選人',
    'consultantLanding.exclusiveEvents': '專屬活動邀請',
    'consultantLanding.consultantCompetitions': '有機會參與BRAIN研究顧問專屬的競賽與聚會',
    'consultantLanding.startJourney': '開始你的BRAIN研究顧問之旅! 🏃',
    'consultantLanding.step1': '第一步: 註冊',
    'consultantLanding.step1.text': '於BRAIN平台創建帳號',
    'consultantLanding.step2': '第二步:學習',
    'consultantLanding.step2.text': '透過Learn頁面學習量化金融研究與模型建立知識',
    'consultantLanding.step3': '第三步:提交Alphas',
    'consultantLanding.step3.text': '提交符合繳交標準的Alphas來累積積分',
    'consultantLanding.step4': '第四步:入職',
    'consultantLanding.step4.text':
      '一旦您在BRAIN平台累積到10,000分，將有機會受邀加入BRAIN研究顧問計畫。成功入職後，您將可能獲得BRAIN顧問專屬的進階功能權限與機會',
    'consultantLanding.eligibleHeader': '如何取得成為BRAIN研究顧問的資格? 🧗',
    'consultantLanding.points': '使用者需要在BRAIN上至少獲得10,000分',
    'consultantLanding.earnBySubmitting': '提交符合<linkThreshold>門檻</linkThreshold>要求的Alphas來獲取積分',
    'consultantLanding.ruleOfThumb': '經驗法則：在5個不同或更多的天數中提交5到10個Alphas，則可能獲得10,000分（一天最多可獲得2,000分）',
    'consultantLanding.backgroundCheck':
      '正式BRAIN研究顧問的身份需要<linkConsultantProcess>完成背景調查</linkConsultantProcess>、顧問協議簽訂以及其他程序',
    'consultantLanding.meetConsultants': '認識我們的BRAIN研究顧問 👨‍💻',
    'consultantLanding.openStarterPack': '開啟新手包',
    'consultantLanding.users': '一般使用者',
    'consultantLanding.consultants': '研究顧問',
    'consultantLanding.compensation': '報酬',
    'consultantLanding.basePayment': '基本報酬',
    'consultantLanding.quarterlyPayment': '季度報酬',
    'consultantLanding.referralProgram': '推薦計畫',
    'consultantLanding.submissionTests': '提交測試',
    'consultantLanding.isPeriod': '樣本內回測期間',
    'consultantLanding.5years': '5年',
    'consultantLanding.10years': '10年',
    'consultantLanding.datasets': '資料集',
    'consultantLanding.regions': '區域',
    'consultantLanding.userRegions': '5個',
    'consultantLanding.consultantRegions': '更多區域',
    'consultantLanding.dataFields': '資料欄',
    'consultantLanding.userDataFields': '約5,000個',
    'consultantLanding.consultantDataFields': '400,000+個',
    'consultantLanding.otherFunctions': '其他功能',
    'consultantLanding.multiSimulation': '多重模擬',
    'consultantLanding.superAlphas': 'SuperAlphas',
    'consultantLanding.visualization': '視覺化',
    'consultantLanding.videoTitle': '加入我們',
    'consultantLanding.videoTitle.logged': '了解更多',
    'consultantLanding.compensationOpportunity.grandmaster': 'Grandmaster 級別顧問有機會獲得8,000美元或更多的季度獎金',
    'consultantLanding.compensationOpportunity.master': 'Master 級別顧問有機會獲得2,000美元或更多的季度獎金',
    'consultantLanding.geniusTitle': '你的 BRAIN 之旅!',
    'consultantLanding.geniusText': '提升 Genius 等級，解鎖更多功能與福利',
  },
  'zh-cn': {
    'consultantLanding.title': '成为BRAIN研究顾问？',
    'consultantLanding.title.logged': 'BRAIN 研究顾问等你加入！',
    'consultantLanding.joinHeader': '探索<b>量化金融</b>的世界',
    'consultantLanding.joinHeader.logged': '加入全球最大的<b>量化金融社区之一</b>！',
    'consultantLanding.leverageOurData': '利用 WorldQuant BRAIN 模拟平台来构建 Alphas ，并为 WorldQuant 的整体研究工作做出贡献。',
    'consultantLanding.leverageOurData.asterix': '\u002AWorldQuant 将能够预测未来金融产品价格走势的数据模型定义为Alphas',
    'consultantLanding.userCount': '用户',
    'consultantLanding.userCount.number': '550,000+',
    'consultantLanding.consultantCount': '顾问',
    'consultantLanding.consultantCount.number': '16,000+',
    'consultantLanding.countriesCount': '国家和地区',
    'consultantLanding.countriesCount.number': '17',
    'consultantLanding.availableInCountries': 'BRAIN 研究顾问项目现已在',
    'consultantLanding.countryList':
      '中国大陆、香港、台湾、肯尼亚、韩国、印度尼西亚、印度、马来西亚、新加坡、英国、越南、泰国、美国、亚美尼亚、匈牙利、尼日利亚和格鲁吉亚开展。',
    'consultantLanding.joinUs': '加入我们',
    'consultantLanding.featuresHeader': '解锁专属功能 🔑',
    'consultantLanding.additionalFields': '更多的数据字段和区域',
    'consultantLanding.exploreAdditional': '获得欧洲和亚洲的400,000 + 数据字段',
    'consultantLanding.moreFeatures': '进阶功能',
    'consultantLanding.openAccess':
      '获取进阶功能权限：更长的回测周期、数据可视化图表、并行回测、通过 Python 调用BRAIN  API、创建 SuperAlphas 等！SuperAlphas…等等更多功能!',
    'consultantLanding.moreLearning': '更多学习资源',
    'consultantLanding.moreAdvancedVideos': '来自我们量化专家的进阶培训视频和实践指导',
    'consultantLanding.meritBased': '绩效津贴',
    'consultantLanding.compensationOpportunity': '有机会将您出众的想法转化为津贴',
    'consultantLanding.career': '潜在的职业机会',
    'consultantLanding.internships': '有機會被考慮為WorldQuant實習與正職職位候選人',
    'consultantLanding.exclusiveEvents': '專屬活動邀請',
    'consultantLanding.consultantCompetitions': '有機會參與BRAIN研究顧問專屬的競賽與聚會',
    'consultantLanding.startJourney': '开启你的BRAIN研究顾问之旅！ 🏃',
    'consultantLanding.step1': '第一步：注册账户',
    'consultantLanding.step1.text': '创建BRAIN平台账户',
    'consultantLanding.step2': '第二步：学习',
    'consultantLanding.step2.text': '在平台内“Learn”专区，学习量化金融研究和建模的相关知识',
    'consultantLanding.step3': '第三步：提交Alphas',
    'consultantLanding.step3.text': '提交符合标准的Alphas以积累积分',
    'consultantLanding.step4': '第四步：顾问申请',
    'consultantLanding.step4.text':
      '在达到10，000分后会成为金牌用户，满足条件的用户有机会获得BRAIN 研究顾问项目的邀请。在完成全部申请流程并审核通过后，' +
      '你将获得进阶的功能和BRAIN顾问专属的活动和机会。',
    'consultantLanding.eligibleHeader': 'BRAIN研究顾问所需条件？ 🧗',
    'consultantLanding.points': '用户需要在 BRAIN 上获得至少 10,000 分',
    'consultantLanding.earnBySubmitting': '提交符合<linkThreshold>测试标准</linkThreshold>的 Alphas 即可获得积分',
    'consultantLanding.ruleOfThumb':
      '通常情况下，您可以在 5 个以上的不同自然日，提交 5 到 10 个  Alphas 即可获得 10,000 积分（单日获取积分上限2000分）',
    'consultantLanding.backgroundCheck':
      '•\tBRAIN 研究顾问资格的获取，需要完成并通过<linkConsultantProcess>背景调查</linkConsultantProcess>、签订咨询协议等其他流程',
    'consultantLanding.meetConsultants': '认识我们的BRAIN 研究顾问 👨‍💻',
    'consultantLanding.openStarterPack': 'Open Starter Pack',
    'consultantLanding.users': 'Users',
    'consultantLanding.consultants': 'Consultants',
    'consultantLanding.compensation': 'Compensation',
    'consultantLanding.basePayment': 'Base payment',
    'consultantLanding.quarterlyPayment': 'Quarterly payment',
    'consultantLanding.referralProgram': 'Referral program',
    'consultantLanding.submissionTests': 'Submission tests',
    'consultantLanding.isPeriod': 'IS testing period',
    'consultantLanding.5years': '5 years',
    'consultantLanding.10years': '10 years',
    'consultantLanding.datasets': 'Datasets',
    'consultantLanding.regions': 'Regions',
    'consultantLanding.userRegions': '5 regions',
    'consultantLanding.consultantRegions': 'More regions',
    'consultantLanding.dataFields': 'Data fields',
    'consultantLanding.userDataFields': 'Around 5000',
    'consultantLanding.consultantDataFields': '400,000+',
    'consultantLanding.otherFunctions': 'Other functionalities',
    'consultantLanding.multiSimulation': 'Multi-simulation',
    'consultantLanding.superAlphas': 'SuperAlphas',
    'consultantLanding.visualization': 'Visualization',
    'consultantLanding.videoTitle': '加入我们',
    'consultantLanding.videoTitle.logged': '了解更多',
    'consultantLanding.compensationOpportunity.grandmaster': 'Grandmaster级别的顾问有机会赚取8000美元或更多的季度奖金',
    'consultantLanding.compensationOpportunity.master': ' Master级别的顾问有机会赚取2000美元或更多的季度奖金',
    'consultantLanding.geniusTitle': 'Your journey on BRAIN!',
    'consultantLanding.geniusText': 'Move up each Genius level and unlock more features and benefits',
  },
  vi: {
    'consultantLanding.title': 'Bạn có thể trở thành BRAIN Research Consultant không?',
    'consultantLanding.title.logged': 'Tham gia chương trình BRAIN Research Consultant!',
    'consultantLanding.joinHeader': 'Bứt phá vào thế giới <b>Tài chính Định lượng</b>!',
    'consultantLanding.joinHeader.logged': 'Tham gia một trong <b>những cộng đồng tài chính định lượng quốc tế lớn nhất thế giới</b>!',
    'consultantLanding.leverageOurData':
      'Sử dụng WorldQuant BRAIN, một nền tảng mô phỏng để xây dựng Alpha và góp phần vào nỗ lực nghiên cứu chung của WorldQuant.',
    'consultantLanding.leverageOurData.asterix':
      '\u002AWorldQuant định nghĩa Alpha là các mô hình toán học nhằm dự đoán biến động giá trong tương lai của nhiều loại công cụ tài chính khác nhau',
    'consultantLanding.userCount': 'user',
    'consultantLanding.userCount.number': '550,000+',
    'consultantLanding.consultantCount': 'consultant',
    'consultantLanding.consultantCount.number': '16,000+',
    'consultantLanding.countriesCount': 'vùng lãnh thổ',
    'consultantLanding.countriesCount.number': '17',
    'consultantLanding.availableInCountries': 'Chương trình BRAIN Research Consultant Program hiện đã có mặt tại ',
    'consultantLanding.countryList':
      'Trung Quốc Đại Lục, Hồng Kông, Đài Loan, Kenya, Hàn Quốc, Indonesia, Malaysia, Singapore, Anh Quốc, Việt Nam, Thái Lan, Mỹ, Armenia, Nigeria và Georgia',
    'consultantLanding.joinUs': 'Đăng ký',
    'consultantLanding.featuresHeader': 'Mở khóa các tính năng đặc biệt 🔑',
    'consultantLanding.additionalFields': 'Thêm nhiều trường dữ liệu và các vùng',
    'consultantLanding.exploreAdditional': 'Khám phá hơn 400,000 trường dữ liệu từ 12 khu vực',
    'consultantLanding.moreFeatures': 'Các tính năng nâng cao',
    'consultantLanding.openAccess':
      'Mở quyền truy cập các tính năng nâng cao: thời gian mô phỏng dài hơn, trực quan hóa dữ liệu, mô phỏng đa luồng, dùng Python để tận dụng API của BRAIN, tạo SuperAlpha và còn nhiều hơn nữa!',
    'consultantLanding.moreLearning': 'CHƯƠNG TRÌNH QUANT ADVISORY',
    'consultantLanding.moreAdvancedVideos':
      'Học theo nhóm được dẫn dắt bởi một chuyên gia nghiên cứu định lượng giàu kinh nghiệm cùng với hỗ trợ thực hành trực tiếp',
    'consultantLanding.meritBased': 'THU NHẬP DỰA TRÊN THÀNH TÍCH',
    'consultantLanding.compensationOpportunity': 'Cơ hội để nhận thu nhập cho các ý tưởng của bạn',
    'consultantLanding.career': 'CƠ HỘI NGHỀ NGHIỆP',
    'consultantLanding.internships': 'Được cân nhắc cho các vị trí thực tập sinh và chính thức tại WorldQuant',
    'consultantLanding.exclusiveEvents': 'CÁC SỰ KIỆN VÀ ƯU ĐÃI RIÊNG',
    'consultantLanding.consultantCompetitions':
      'Cơ hội để tham gia các cuộc thi và các buổi gặp mặt được tổ chức riêng cho BRAIN Research Consultant',
    'consultantLanding.startJourney': 'Bắt đầu hành trình BRAIN Research Consultant của bạn ngay thôi nào! 🏃',
    'consultantLanding.step1': 'Bước 1: Đăng ký',
    'consultantLanding.step1.text': 'Tạo tài khoản trên BRAIN',
    'consultantLanding.step2': 'Bước 2: Học hỏi',
    'consultantLanding.step2.text': 'Nâng cao kiến thức của bạn về nghiên cứu và xây dựng mô hình tài chính định lượng thông qua mục Learn',
    'consultantLanding.step3': 'Bước 3: Nộp Alpha',
    'consultantLanding.step3.text': 'Tích lũy điểm bằng các nộp các Alpha đáp ứng tiêu chí của chúng tôi',
    'consultantLanding.step4': 'Bước 4: Onboard',
    'consultantLanding.step4.text':
      'Khi bạn đạt 10,000 điểm trên BRAIN và đạt hạng Gold, bạn có thể sẽ nhận được một thư mời tham gia chương trình BRAIN Research Consultant. ' +
      'Sau khi onboard thành công, bạn sẽ có quyền truy cập các tính năng nâng cao và các cơ hội dành riêng cho BRAIN consultant',
    'consultantLanding.eligibleHeader': 'Điều kiện để trở thành BRAIN Research Consultant là gì? 🧗',
    'consultantLanding.points': 'User cần đạt được ít nhất 10,000 điểm trên BRAIN',
    'consultantLanding.earnBySubmitting': 'Điểm có thể đạt được bằng cách nộp các Alpha đạt đủ <linkThreshold>điều kiện</linkThreshold>',
    'consultantLanding.ruleOfThumb':
      'Nguyên tắc chung: bạn có thể đạt được 10,000 điểm bằng các nộp từ 5 đến 10 Alpha ít nhất 5 ngày khác nhau (bạn chỉ có thể đạt tối đa 2,000 trong một ngày)',
    'consultantLanding.backgroundCheck':
      'Để chính thức trở thành BRAIN Consultant bạn phải hoàn thành việc <linkConsultantProcess>kiểm tra lý lịch</linkConsultantProcess>, ký kết thỏa thuận tư vấn và các thủ tục khác',
    'consultantLanding.meetConsultants': 'Gặp gỡ một số BRAIN Research Consultant của chúng tôi 👨‍💻',
    'consultantLanding.openStarterPack': 'Khám phá Starter Pack',
    'consultantLanding.users': 'User',
    'consultantLanding.consultants': 'Consultant',
    'consultantLanding.compensation': 'Thu nhập',
    'consultantLanding.basePayment': 'Thanh toán cơ bản',
    'consultantLanding.quarterlyPayment': 'Thanh toán theo quý',
    'consultantLanding.referralProgram': 'Chương trình giới thiệu',
    'consultantLanding.submissionTests': 'Submission Test',
    'consultantLanding.isPeriod': 'Thời gian IS Testing',
    'consultantLanding.5years': '5 năm',
    'consultantLanding.10years': '10 năm',
    'consultantLanding.datasets': 'Dataset',
    'consultantLanding.regions': 'Region',
    'consultantLanding.userRegions': '5 region',
    'consultantLanding.consultantRegions': 'Nhiều region hơn',
    'consultantLanding.dataFields': 'Các trường dữ liệu',
    'consultantLanding.userDataFields': 'Khoảng 5,000',
    'consultantLanding.consultantDataFields': '400,000+',
    'consultantLanding.otherFunctions': 'Các tính năng khác',
    'consultantLanding.multiSimulation': 'Mô phỏng đa luồng',
    'consultantLanding.superAlphas': 'SuperAlpha',
    'consultantLanding.visualization': 'Trực quan hóa',
    'consultantLanding.videoTitle': 'Tham gia cùng chúng tôi',
    'consultantLanding.videoTitle.logged': 'Tìm hiểu thêm',
    'consultantLanding.compensationOpportunity.grandmaster':
      'Consultant đạt level Grandmaster có thể kiếm được từ 8,000 USD hoặc hơn cho khoản thanh toán theo quý',
    'consultantLanding.compensationOpportunity.master':
      'Consultant đạt level Master có thể kiếm được từ 2,000 USD hoặc hơn cho khoản thanh toán theo quý',
    'consultantLanding.geniusTitle': 'Hành trình của bạn trên BRAIN!',
    'consultantLanding.geniusText': 'Thăng hạng qua từng cấp độ Genius và mở khóa thêm nhiều tính năng cùng quyền lợi mới',
  },
  ko: {
    'consultantLanding.title': 'BRAIN 리서치 컨설턴트가 될 준비가 되셨나요?',
    'consultantLanding.title.logged': '이제 BRAIN 리서치 컨설턴트로 전환하세요!',
    'consultantLanding.joinHeader': '<b>퀀트투자의</b> 세계로 입문하기에  최적의 프로그램!',
    'consultantLanding.joinHeader.logged': '<b>세계에서 가장 큰 규모의 글로벌 퀀트투자</b> 커뮤니티의 일원이 되세요!',
    'consultantLanding.leverageOurData':
      'WorldQuant 의 웹기반 백테스팅 시뮬레이터 BRAIN을 통해 Alpha*를 개발하여 WorldQuant의 퀀트 연구에 참여해 보세요!',
    'consultantLanding.leverageOurData.asterix':
      '\u002AWorldQuant는 “Alpha”를 각종 데이터를 이용해 미래 주가의 움직임을 예측하는 수학적 모델로 정의합니다.',
    'consultantLanding.userCount': '사용자',
    'consultantLanding.userCount.number': '550,000+',
    'consultantLanding.consultantCount': '컨설턴트',
    'consultantLanding.consultantCount.number': '16,000+',
    'consultantLanding.countriesCount': '국가',
    'consultantLanding.countriesCount.number': '17',
    'consultantLanding.availableInCountries': 'BRAIN 리서치 컨설턴트 프로그램은 현재 ',
    'consultantLanding.countryList':
      '한국, 중국, 홍콩, 대만, 케냐, 인도네시아, 인도, 말레이시아, 싱가포르, 영국, 베트남, 태국, 미국, 아르메니아, 헝가리, 나이지리아 및 조지아에서 운영되고 있습니다.',
    'consultantLanding.joinUs': '지금 가입하세요',
    'consultantLanding.featuresHeader': '컨설턴트에게만 열리는 다양한 혜택과 기능 🔑',
    'consultantLanding.additionalFields': '추가되는 데이터필드 및 투자 가능 지역',
    'consultantLanding.exploreAdditional':
      '미국과 중국 뿐 아니라 유럽과 아시아(한국 등)에서 사용 가능한 40만개 이상의 데이터필드가 주어집니다. ',
    'consultantLanding.moreFeatures': '추가되는 고급 기능',
    'consultantLanding.openAccess':
      '컨설턴트가 되면 시뮬레이션 기간이 늘어나며, 데이터 시각화 및 멀티 시뮬레이션 기능, Python을 이용한 BRAIN의 API 활용, SuperAlpha를 개발할 수 있는 추가적인 기능들이 생깁니다!',
    'consultantLanding.moreLearning': '고급 학습 자료',
    'consultantLanding.moreAdvancedVideos': '숙련된 퀀트 전문가로부터 더욱 수준 높은 교육 컨텐츠와 멘토링을 받을 수 있습니다.',
    'consultantLanding.meritBased': '성과 기반 보상',
    'consultantLanding.compensationOpportunity': '제출한 알파 아이디어의 실제 성능에 따라 보상을 받을 수 있게 됩니다.',
    'consultantLanding.career': '잠재적 커리어 기회',
    'consultantLanding.internships': 'WorldQuant 인턴십 및 정규직 채용의 기회가 생길 수 있습니다.',
    'consultantLanding.exclusiveEvents': '특별한 이벤트 및 커뮤니티 네트워킹',
    'consultantLanding.consultantCompetitions':
      'BRAIN 리서치 컨설턴트들을 위해 개최되는 특별한 대회 및 다양한 네트워킹 행사에 참여할 수 있습니다.',
    'consultantLanding.startJourney': 'BRAIN 리서치 컨설턴트가 되는 과정 🏃',
    'consultantLanding.step1': 'Step 1: Sign up',
    'consultantLanding.step1.text': '간단한 가입 절차를 통해 BRAIN 계정을 생성합니다.',
    'consultantLanding.step2': 'Step 2: Learn',
    'consultantLanding.step2.text':
      'BRAIN의 Learn 메뉴에서 접할 수 있는 퀀트투자에 대한 다양한 교육 컨텐츠(한국어 동영상 강의, 라이브 웨비나, 게시글 등)들을 통해 학습을 진행합니다.',
    'consultantLanding.step3': 'Step 3: Submit Alphas',
    'consultantLanding.step3.text': 'BRAIN 플랫폼의 제출 기준을 충족하는 Alpha를 제출(submit)하면 점수가 쌓입니다.',
    'consultantLanding.step4': 'Step 4: Onboard',
    'consultantLanding.step4.text':
      '약 5~10개의 Alpha를 제출하여 Challenge 점수 10,000점을 달성하면 Gold Level Certificate과 함께 BRAIN 리서치 컨설턴트 전환 ' +
      '과정에 대한 안내 메일을 받습니다. 신원조회 과정을 거쳐 성공적으로 BRAIN 컨설턴트 계정으로 전환을 완료하면, 다양한 고급 기능과 기회를 누리실 수 있습니다.',
    'consultantLanding.eligibleHeader': 'BRAIN 리서치 컨설턴트가 되려면 어떻게 해야 하나요? 🧗',
    'consultantLanding.points': 'BRAIN 플랫폼에서 Challenge 점수 10,000점을 적립해야 합니다.',
    'consultantLanding.earnBySubmitting': '점수를 쌓으려면  <linkThreshold>제출기준을</linkThreshold> 충족하는 Alpha를 제출해야 합니다',
    'consultantLanding.ruleOfThumb':
      '약 5~10일에 걸쳐 Alpha 5~10개를 제출하면 10,000점을 달성하여 Gold Level에 도달할 수 있습니다. (Challenge 점수는 하루 최대 2,000점까지 적립 가능하므로 여러 날에 걸쳐서 알파를 제출해야 합니다.)',
    'consultantLanding.backgroundCheck':
      'Gold Level Certificate과 BRAIN 리서치 컨설턴트 전환 관련 안내 메일을 받은 뒤, 가이드라인에 따라 간단한 ' +
      ' <linkConsultantProcess>온라인 신원조회</linkConsultantProcess> 절차가 진행되며, 컨설턴트 계약 전자서명을 마치면 성공적으로 BRAIN 컨설턴트 계정으로 업그레이드가 됩니다.',
    'consultantLanding.meetConsultants': '글로벌 BRAIN 리서치 컨설턴트들을 이야기를 들어보세요! 👨‍💻',
    'consultantLanding.openStarterPack': 'Starter Pack 바로가기',
    'consultantLanding.users': '일반 User',
    'consultantLanding.consultants': '컨설턴트',
    'consultantLanding.compensation': '보상',
    'consultantLanding.basePayment': '기본급 (Base payment)',
    'consultantLanding.quarterlyPayment': '분기 성과급 (Quarterly payment)',
    'consultantLanding.referralProgram': '소개 수수료 (Referral fee)',
    'consultantLanding.submissionTests': '제출 기준',
    'consultantLanding.isPeriod': 'In-Sample 테스팅 기간',
    'consultantLanding.5years': '5년',
    'consultantLanding.10years': '10년',
    'consultantLanding.datasets': '데이터셋',
    'consultantLanding.regions': '투자 가능 지역 (Region)',
    'consultantLanding.userRegions': '5년',
    'consultantLanding.consultantRegions': '10년',
    'consultantLanding.dataFields': '데이터 필드',
    'consultantLanding.userDataFields': '약 5,000개',
    'consultantLanding.consultantDataFields': '약 400,000개',
    'consultantLanding.otherFunctions': '그 밖의 기능',
    'consultantLanding.multiSimulation': '멀리 시뮬레이션 기능',
    'consultantLanding.superAlphas': 'API 활용 및 SuperAlpha 제출 기능',
    'consultantLanding.visualization': '데이터 시각화 기능',
    'consultantLanding.videoTitle': '지금 가입하세요',
    'consultantLanding.videoTitle.logged': '컨설턴트 프로그램 알아보기',
    'consultantLanding.compensationOpportunity.grandmaster':
      'Grand Master레벨에 해당되는 컨설턴트는 분기별로 USD $8,000이상을 벌 수 있습니다.',
    'consultantLanding.compensationOpportunity.master': 'Master레벨에 해당되는 컨설턴트는 분기별로 USD $2,000 이상을 벌 수 있습니다.',
    'consultantLanding.geniusTitle': 'Your journey on BRAIN!',
    'consultantLanding.geniusText': 'Move up each Genius level and unlock more features and benefits',
  },
  en: {
    'consultantLanding.title': 'Could you be a BRAIN Research Consultant?',
    'consultantLanding.title.logged': 'Join the BRAIN Research Consultant Program!',
    'consultantLanding.joinHeader': 'Break into the world of <b>Quantitative Finance!</b>',
    'consultantLanding.joinHeader.logged': 'Join one of the world’s largest <b>global quant finance communities!</b>',
    'consultantLanding.leverageOurData':
      'Leverage WorldQuant BRAIN, a simulation platform to build Alphas* and contribute to WorldQuant’s overall research effort.',
    'consultantLanding.leverageOurData.asterix':
      '\u002AWorldQuant defines Alphas as mathematical models that seek to predict the future price movements of various financial instruments',
    'consultantLanding.userCount': 'users',
    'consultantLanding.userCount.number': '550,000+',
    'consultantLanding.consultantCount': 'consultants',
    'consultantLanding.consultantCount.number': '16,000+',
    'consultantLanding.countriesCount': 'regions',
    'consultantLanding.countriesCount.number': '17',
    'consultantLanding.availableInCountries': 'Our BRAIN Research Consultant Program is now available in ',
    'consultantLanding.countryList':
      'Mainland China, Hong Kong, Taiwan, Kenya, South Korea, Indonesia, India, Malaysia, Singapore, UK, Vietnam, Thailand, US, Armenia, Hungary, Nigeria and Georgia',
    'consultantLanding.joinUs': 'Join us',
    'consultantLanding.featuresHeader': 'Unlock exclusive features',
    'consultantLanding.additionalFields': 'Additional Data Fields and Regions Access',
    'consultantLanding.exploreAdditional': 'Explore 400,000+ data fields from 12 regions',
    'consultantLanding.moreFeatures': 'Advanced Features',
    'consultantLanding.openAccess':
      'Open access to advanced features: longer simulation periods, data visualizations, multi-simulation, leveraging BRAIN’s API with Python, creating SuperAlphas and much more!',
    'consultantLanding.moreLearning': 'Quant Advisory Program',
    'consultantLanding.moreAdvancedVideos': 'Cohort-based learning guided by an experienced quant researcher and hands-on support',
    'consultantLanding.meritBased': 'Merit-Based Compensation',
    'consultantLanding.compensationOpportunity': 'Have the opportunity to be compensated for the quality of your ideas \n',
    'consultantLanding.compensationOpportunity.grandmaster':
      'Grandmaster level consultants can potentially earn upwards of $8,000 or more in a quarterly payment amount',
    'consultantLanding.compensationOpportunity.master':
      'Master level consultants can potentially earn upwards of $2,000 or more in a quarterly payment amount',
    'consultantLanding.career': 'Potential Career Opportunities',
    'consultantLanding.internships': 'Be considered for possible internships and full-time positions at WorldQuant',
    'consultantLanding.exclusiveEvents': 'Exclusive Events and Offers',
    'consultantLanding.consultantCompetitions':
      'Opportunity to join competitions and meetups organized exclusively for BRAIN Research Consultants ',
    'consultantLanding.startJourney': 'Start your BRAIN Research Consultant journey!',
    'consultantLanding.step1': 'Step 1: Sign up',
    'consultantLanding.step1.text': 'Create an account on BRAIN',
    'consultantLanding.step2': 'Step 2: Learn',
    'consultantLanding.step2.text': 'Grow your knowledge of quantitative finance research and modeling through the Learn section',
    'consultantLanding.step3': 'Step 3: Submit Alphas',
    'consultantLanding.step3.text': 'Accumulate points by submitting your Alphas that meet our submission criteria',
    'consultantLanding.step4': 'Step 4: Onboard',
    'consultantLanding.step4.text':
      'Once you hit 10,000 points on BRAIN and reach gold, you may receive an invitation to join the BRAIN Research Consultant Program. ' +
      'Once you are successfully on-boarded, you would gain access to the advanced features and opportunities available to BRAIN Consultants ',
    'consultantLanding.eligibleHeader': 'Eligibility to become a BRAIN RESEARCH Consultant',
    'consultantLanding.points': 'Users need to score at least 10,000 points on the BRAIN',
    'consultantLanding.earnBySubmitting':
      'Points can be earned by submitting Alphas that meet our <linkThreshold>thresholds</linkThreshold>',
    'consultantLanding.ruleOfThumb':
      'Rule of thumb: you can earn 10,000 points by submitting 5 to 10 Alphas on 5 or more distinct days (2,000 points is the maximum number of points that can be earned in a single day)',
    'consultantLanding.backgroundCheck':
      'Full BRAIN Research Consultant status is subject to satisfactory completion of a <linkConsultantProcess>background check</linkConsultantProcess>, entering into a consulting agreement and other procedures',
    'consultantLanding.meetConsultants': 'Meet some of our BRAIN Research Consultants',
    'consultantLanding.openStarterPack': 'Open Starter Pack',
    'consultantLanding.users': 'Users',
    'consultantLanding.consultants': 'Consultants',
    'consultantLanding.compensation': 'Compensation',
    'consultantLanding.basePayment': 'Base payment',
    'consultantLanding.quarterlyPayment': 'Quarterly payment',
    'consultantLanding.referralProgram': 'Referral program',
    'consultantLanding.submissionTests': 'Submission tests',
    'consultantLanding.isPeriod': 'IS testing period',
    'consultantLanding.5years': '5 years',
    'consultantLanding.10years': '10 years',
    'consultantLanding.datasets': 'Datasets',
    'consultantLanding.regions': 'Regions',
    'consultantLanding.userRegions': '5 regions',
    'consultantLanding.consultantRegions': 'More regions',
    'consultantLanding.dataFields': 'Data fields',
    'consultantLanding.userDataFields': 'Around 5,000',
    'consultantLanding.consultantDataFields': '400,000+',
    'consultantLanding.otherFunctions': 'Other functionalities',
    'consultantLanding.multiSimulation': 'Multi-simulation',
    'consultantLanding.superAlphas': 'SuperAlphas',
    'consultantLanding.visualization': 'Visualization',
    'consultantLanding.videoTitle': 'Join us',
    'consultantLanding.videoTitle.logged': 'Learn more',
    'consultantLanding.geniusTitle': 'Your journey on BRAIN!',
    'consultantLanding.geniusText': 'Move up each Genius level and unlock more features and benefits',
    'consultantLanding.copyrightText': `Copyright © {year} WorldQuant, LLC. All Rights Reserved.`,
  },
};
